var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { singleton } from 'tsyringe';
import { BaseSingletonService } from '~/services/service.base';
export let ServiceIframe = class ServiceIframe extends BaseSingletonService {
    constructor() {
        super();
    }
    get inIframe() {
        try {
            return window.self !== window.top;
        }
        catch (e) {
            return true;
        }
    }
    setIframeStyles() {
        if (!this.inIframe) {
            return;
        }
        try {
            const adminToolBar = parent.document.getElementById('wpadminbar');
            const header = parent.document.getElementById('header-container');
            if (adminToolBar) {
                const headerHeight = adminToolBar.offsetHeight + (header?.offsetHeight || 0);
                const iframe = parent.document.getElementById('linkavie-iframe');
                if (iframe) {
                    iframe.style.height = `calc(100vh - ${headerHeight}px)`;
                    iframe.style.position = 'fixed';
                    iframe.style.bottom = '0';
                    iframe.style.left = '0';
                    iframe.style.right = '0';
                }
            }
        }
        catch (e) {
            console.log('Using default iframe styles');
        }
    }
};
ServiceIframe = __decorate([
    singleton(),
    __metadata("design:paramtypes", [])
], ServiceIframe);
